import { format } from 'date-fns';
import { get } from 'lodash';
import React, { Component, Fragment } from 'react';
import Link from 'gatsby-link';
import styled, { css } from 'styled-components';
import { theme } from '@upsolve/ui';

import LinkCSS from '../Links/A.css';
import { Button } from '../Inputs/Button.span';

import Logo from '../../../static/images/upsolve-logo.svg';
import IconMenu from '../../../static/images/icon-menu.svg';
import IconClose from '../../../static/images/icon-close.svg';
import { withAmp } from '../AMP/AmpContext';
import DebtIncrementer from '../ProofBuilders/DebtIncrementer';

class MainHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFurlough: false,
      isLanding: false,
      isReviewing: false,
      loaded: false,
      menuShowing: false,
    };
  }

  componentDidMount() {
    const isLanding = get(location, 'pathname', '') === '/';
    const isReviewing = /\/review/gmi.test(get(location, 'pathname', ''));
    const isFurlough = /\/furlough/gmi.test(get(location, 'pathname', ''));
    // Only update state if we need to. Flash
    this.setState({ isFurlough, isLanding, isReviewing, loaded: true });
  }

  render() {
    const { amp } = this.props;
    const { loaded, isFurlough, isLanding, isReviewing } = this.state;
    let { showHelloBar, helloBarTemplate, helloBarText, helloBarUrl } = this.props;

    // Defaults
    if (showHelloBar == null) {
      showHelloBar = true;
      helloBarTemplate = 'debtCleared';
    }

    return (
      <div>
        {showHelloBar !== false && (
          <Fragment>
            {helloBarTemplate === 'debtCleared' && (
              <HelloBar>
                <a aria-busy="false" href='https://my.upsolve.org/screener'>
                  <u>Upsolve's helped families clear <span className="incrementer">$<DebtIncrementer /></span> of debt</u>
                </a>
              </HelloBar>
            )}
            {helloBarTemplate === 'link' && (
              <HelloBar>
                <a aria-busy="false" href={helloBarUrl || 'https://my.upsolve.org/screener'}>
                  {helloBarText || 'Upsolve has cleared $120,000,000+ debt for hundreds of families'}
                </a>
              </HelloBar>
            )}
          </Fragment>
        )}
        <HeaderContainer color={this.props.color}>
          <div>
            <div className="nav__left">
              <div className="mobile-menu-handler">
                {amp !== true && (
                  <IconMenu
                    aria-busy="false"
                    aria-label="Open Menu"
                    role="button"
                    className="icon-menu"
                    onClick={() => this.setState(prevState => ({ ...prevState, menuShowing: true }))}
                  />
                )}
                <span
                  role="button"
                  aria-label="Open Menu"
                  onClick={() => this.setState(prevState => ({ ...prevState, menuShowing: true }))}
                >
                  <Logo />
                </span>
              </div>
              <div className="hide-sm">
                <Link aria-busy="false" to="/"><Logo /></Link>
              </div>
              <Link aria-busy="false" className="hide-sm" to="/learn/transparency/">How Our Service is Free</Link>
              <Link aria-busy="false" className="hide-sm" to="/how-we-work/">How it Works</Link>
              <Link aria-busy="false" className="hide-sm" to="/team/">Team</Link>
              <Link aria-busy="false" className="hide-md" to="/learn/">Learning</Link>
              <Link aria-busy="false" className="hide-sm" to="/fresh-starts/">Community</Link>
            </div>
            <div className="nav__right">
              <a aria-busy="false" href="https://my.upsolve.org/login" className="hide-sm">Sign In</a>
              <a aria-busy="false" href="https://my.upsolve.org/screener"><Button size="sm" inverted>Get Free Bankruptcy Help</Button></a>
            </div>
          </div>
        </HeaderContainer>
        <MobileMenu
          aria-hidden={this.state.menuShowing === true ? 'false' : 'true'}
          className={this.state.menuShowing === true ? 'show' : ''}
        >
          <div className={`panel ${this.state.menuShowing === true ? 'show' : ''}`}>
            <div
              role="button"
              aria-busy="false"
              aria-label="Close Menu"
              className="panel__header"
              onClick={() => this.setState(prevState => ({ ...prevState, menuShowing: false }))}
            >
              <IconClose />
            </div>
            <div className="panel__nav">
              <ul>
                <li><a href="https://my.upsolve.org/screener">Get Bankruptcy Help</a></li>
                <li><a href="https://my.upsolve.org/screener">Sign In</a></li>
                <li><Link aria-busy="false" to="/">Home</Link></li>
                <li><Link aria-busy="false" to="/learn/transparency/">How Upsolve's Service is Free</Link></li>
                <li><Link aria-busy="false" to="/how-we-work/">How Upsolve Works</Link></li>
                <li><Link aria-busy="false" to="/team/">Team</Link></li>
                <li><Link aria-busy="false" to="/learn/">Learning Center</Link></li>
                <li><Link aria-busy="false" to="/fresh-starts/">Fresh Starts</Link></li>
                <li><Link aria-busy="false" to="/donate/">Donate</Link></li>
                <li><Link aria-busy="false" to="/fresh-starts/">Community</Link></li>
              </ul>
            </div>
          </div>
          <div
            role="button"
            aria-busy="false"
            aria-label="Click back to page"
            aria-hidden={this.state.menuShowing === true ? 'false' : 'true'}
            className={`backdrop ${this.state.menuShowing === true ? 'show' : ''}`}
            onClick={() => this.setState(prevState => ({ ...prevState, menuShowing: false }))}
          />
        </MobileMenu>
      </div>
    );
  }
}


const HelloBar = styled.div`
  text-align: center;
  background: ${theme.colors.white['600']};
  display: flex;
  color: ${theme.colors.brand['500']};
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.25px;
  a {
    width: 100%;
    padding: .5em;
    color: ${theme.colors.brand['500']};
    text-decoration: none;
  }
  .incrementer {
    width: 400px;
    min-width: 400px;
  }

  @media(max-width: 45em) {
    font-size: 13px;
    font-weight: initial;
    letter-spacing: 0;
  }
`;

const HeaderContainer = styled.nav`
  background: ${theme.colors.white['900']};
  box-shadow: none;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${theme.colors.white['800']};
  padding: 0 3em;
  svg {
    display: block;
    height: 32px;
    width: 140px;
    margin-top: -2px;
    @media(max-width: 45em) {
      height: 28px;
      width: 120px;
      margin-top: 0;
    }
    path {
      fill: ${theme.colors.brand['500']};
    }
    ${(props) => {
      if (props.color === 'white') {
        return css`
          path {
            fill: ${theme.colors.white['900']};
          }
        `;
      }
    }}
  }
  a {
    color: ${theme.colors.gray['800']};
    display: flex;
    align-items: center;
    button {
      font-weight: 700;
    }
    @media (max-width: 45em) {
      font-size: 14px;
    }
    ${(props) => {
      if (props.color === 'white') {
        return css`
          &, &:hover {
            color: white;
          }
        `;
      }
    }}
  }
  & > div {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 1em 0;
    align-items: center;
  }

  div.nav__left {
    display: flex;
    justify-content: flex-end;
    & > div {
      margin-right: 1em;
    }
    a {
      padding-left: 1.5em;
      font-size: 15px;
      &:first-of-type {
        padding: 0;
      }
      ${(props) => {
        if (props.color === 'white') {
          return css`
            &, &:hover {
              color: white;
            }
          `;
        }
      }}
    }
    .mobile-menu-handler {
      display: none;
      .icon-menu {
        position: absolute;
        height: 24px;
        width: 24px;
        left: -8px;
        path {
          fill: ${theme.colors.brand['500']};
        }
        opacity: 0.3;
      }
      @media(max-width: 45em) {
        display: inline-flex;
        align-items: center;
      }
    }
  }

  .nav__right {
    display: flex;
    button {
      margin-left: 1.5em;
    }
    @media(max-width: 45em) {
      font-size: 0.9em;
      button {
        padding: 0.5em 1em;
        margin-left: 0;
      }
    }
  }

  .hide-sm {
    @media(max-width: 45em) {
      display: none;
    }
  }
  .hide-md {
    @media(max-width: 60em) {
      display: none;
    }
  }
  .hide-lg {
    @media(max-width: 75em) {
      display: none;
    }
  }
  .show-sm {
    display: none;
    @media(max-width: 45em) {
      display: block;
    }
  }
  @media(max-width: 45em) {
    padding: 0 1em;
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: none;
  .panel {
    position: absolute;
    z-index: 1002;
    width: 80%;
    height: 100%;
    background: white;
    transform: translateX(-100%);
    transition: 250ms;
    transition-timing-function: ease-in-out;
    &.show {
      transform: translateX(0%);
      box-shadow: 0 5px 32px -5px rgba(0, 0, 0, .25);
      pointer-events: all;
    }
  }
  .panel__header {
    padding: 1.5em;
    svg {
      width: 18px;
      height: 18px;
      path {
        fill: ${theme.colors.gray['300']};
      }
    }
  }
  .backdrop {
    position: fixed;
    z-index: 1001;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${theme.colors.white['700']};
    opacity: 0;
    transition: 250ms;
    transition-timing-function: ease-in-out;
    &.show {
      opacity: 0.8;
      pointer-events: all;
    }
  }
  li {
    padding: 1em 1.5em;
    font-size: 1.1em;
    border-bottom: 2px solid ${theme.colors.white['800']};
    a {
      ${LinkCSS}
    }
  }
`;

export default withAmp(MainHeader);
